import styled from "@emotion/styled";
import { Helmet } from "react-helmet";
import SideBar from "components/sidebar/Sidebar";
import { useGetGamesQuery } from "generated/graphql";
import NavBar from "components/navbar/NavBar";
import { Link } from "react-router-dom";
import { LoggedInUserContext } from "contexts/user";
import { useContext } from "react";

const GamesPageWrapper = styled.div`
  > * {
    margin: 0;
    padding: 0;
    background-color: #282c38;
    font-family: "Rajdhani", sans-serif;
    color: #ffffff;
  }

  /* Side Navbar */

  .sponsor {
    width: 100;
    height: 30px;
    margin-top: 0px;
    margin-left: -5px;
  }

  .sidebar {
    width: 200px;
    height: 100%;
    background: #701129;
    padding: 30px 0px;
    position: fixed;
  }

  .side-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
    margin-left: 50px;
    margin-top: -20px;
  }

  .search {
    width: 170px;
    height: 35px;
    margin-left: 15px;
  }

  .sidebar ul {
    list-style-type: none;
    margin-top: -10px;
  }

  .sidebar ul li {
    padding: 15px;
  }

  .sidebar ul li a {
    color: #ffffff;
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    margin-right: 35px;
  }

  /* Top Navbar */

  .profilePic img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  /* All Games */

  .games_title {
    margin-left: 230px;
    margin-top: -30px;
  }

  .filter_btn {
    margin-left: 1110px;
    margin-top: 20px;
    width: 100px;
    height: 30px;
    text-align: left;
    background: #1d2029;
    border: 2px solid #1d2029;
    color: white;
    font-size: 15px;
    border-radius: 3px;
  }

  .filter_btn img {
    width: 12px;
    padding-left: 30px;
    padding-top: 2px;
  }

  .game_container {
    display: grid;
    grid-template-columns: 200px 200px 200px 200px 200px;
    grid-gap: 10px;
    background-color: transparent;
    margin-top: 20px;
    margin-left: 200px;
  }

  .game_container > div {
    text-align: center;
    padding: 20px 0;
    font-size: 30px;
  }

  .game_container > div img {
    width: 140px;
    height: 182px;
    border-radius: 5px;
    box-shadow: #282c38;
  }

  .item1 p {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .item2 p {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .item3 p {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .item4 p {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .item5 p {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
`;

function GamesPage() {
  const { data: games, loading: loadingGames } = useGetGamesQuery({
    nextFetchPolicy: "cache-first",
  });

  const me = useContext(LoggedInUserContext);

  return (
    <GamesPageWrapper>
      <Helmet>
        <title>Games — Jiwe eSports</title>
      </Helmet>
      <div className="wrapper">
        <SideBar nickname={me?.nickname} isLoggedIn={!!me?.nickname} />
        {me && <NavBar nickname={me?.nickname} name={me?.name} />}
      </div>

      <button className="filter_btn">
        Filter <img src="/images/Back 1.png" alt="" />
      </button>

      <h2 className="games_title">All Games</h2>

      <div className="game_container">
        {!loadingGames &&
          games &&
          games.games.map((game) => (
            <div className="item1">
              <Link to={`/games/${game.id}`} title={game.name}>
                <img
                  // @ts-ignore
                  src={game.poster_url!}
                  alt=""
                />
              </Link>
            </div>
          ))}
      </div>
    </GamesPageWrapper>
  );
}

export default GamesPage;
